import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=fa9d8426"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports